import { Box, } from "@chakra-ui/react";

export function CameraMaskView() {
  return (
    <Box
      h="100vh"
      w="100%"
      position="absolute"
      top="0"
      left="0"
      zIndex={100}
      pointerEvents="none"
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        w="80%"
        maxW="400px"
        transform="translate(-50%, -50%)"
        borderRadius="8px"
        sx={{ aspectRatio: "1 / 1" }}
        boxShadow="0 0 0 9999px rgba(0, 0, 0, 0.6)"
        border="2px solid #ffffff"
      />
    </Box>
  );
}
